<template lang="html">

  <li :liked="itsLiked(slug)" class="sendlike" @click="requestLike()"><i class="fa fa-heart-o" aria-hidden="true"></i><span>{{localLikes}}</span></li>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  export default  {
    name: 'like',
    props: ['slug', 'likes'],
    mounted() {
    },
    data() {
      return {
        localLikes : this.likes
      }
    },
    methods: {
      requestLike : function (){
        this.sendLike(this.slug)
        .then(r => {
          this.localLikes = r;
        }).catch(e => {

        })
      },
      ...mapActions({
        sendLike : 'sendLike'
      })
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage',
        server : 'getServer',
        itsLiked : 'getlike'
      }),
    }
  }
</script>

<style scoped>
 .sendlike{
    z-index: 3;
    position: relative;
    cursor: pointer;
  }

  .sendlike[liked="true"]{
    pointer-events: none;
  }

  .sendlike[liked="true"] .fa{
    color: #054279;
  }

  .sendlike[liked="true"] .fa::before{
    content: '\f004';
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/like.vue